import { render, staticRenderFns } from "./BulkMailing.vue?vue&type=template&id=68e84262&scoped=true&"
import script from "./BulkMailing.vue?vue&type=script&lang=js&"
export * from "./BulkMailing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68e84262",
  null
  
)

export default component.exports